import { Directive, HostBinding } from '@angular/core';

@Directive({
    standalone: false,
  selector: '[appDnd]'
})
export class DndDirective {

  @HostBinding('class.fileover') fileOver: boolean;

  constructor() { }

}
